/* Merme Craft Modal — open/close + image lightbox. Opened by any element with
   [data-craft-modal-open]. */
(function () {
  function modal() { return document.querySelector('[data-craft-modal]'); }

  function open() {
    var m = modal(); if (!m) return;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cm-no-scroll');
    document.body.style.overflow = 'hidden';
    var dlg = m.querySelector('.cm__dialog'); if (dlg) dlg.focus();
  }
  function close() {
    var m = modal(); if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cm-no-scroll');
    document.body.style.overflow = '';
    closeZoom();
  }
  function openZoom(src) {
    var m = modal(); if (!m) return;
    var lb = m.querySelector('[data-craft-lightbox]');
    var img = m.querySelector('[data-craft-lightbox-img]');
    if (!lb || !img) return;
    img.src = src; lb.hidden = false;
  }
  function closeZoom() {
    var m = modal(); if (!m) return;
    var lb = m.querySelector('[data-craft-lightbox]');
    if (lb) lb.hidden = true;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-craft-modal-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-craft-zoom-close]')) { closeZoom(); return; }
    if (e.target.closest('[data-craft-close]')) { close(); return; }
    var zoom = e.target.closest('[data-craft-zoom]');
    if (zoom) { openZoom(zoom.getAttribute('data-src')); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = modal(); if (!m || !m.classList.contains('is-open')) return;
    var lb = m.querySelector('[data-craft-lightbox]');
    if (lb && !lb.hidden) { closeZoom(); } else { close(); }
  });
})();
